import { Box } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants';

export const GiftCardContainer = Box.withConfig({
  // width: 343,
  height: 190,
  flexDirection: 'row',
  alignItems: 'flex-start',
  alignSelf: 'center',
  paddingTop: '$4',
  paddingLeft: '$4',
  backgroundColor: primitive.$meltyYellow,
  borderRadius: 10,
  marginY: '$4',
});

export const LogoAndNameContainer = Box.withConfig({
  flexDirection: 'column',
});

export const BackgroundAndLogoContainer = Box.withConfig({
  flex: 1,
  flexDirection: 'row',
  justifyContent: 'space-between',
});
